// Copyright © 2021 Move Closer
import { NewsBarColor } from './NewsBar.contracts';
/**
 * @author Sebastian Dziechciarz, Stanisław Gregor
 */
export const newsBarConfig = {
    [NewsBarColor.Black]: {
        bgClass: 'bg-gray-90',
        textClass: 'text-white'
    },
    [NewsBarColor.Blue]: {
        bgClass: 'bg-blue-80',
        textClass: 'text-white'
    },
    [NewsBarColor.Brand]: {
        bgClass: 'bg-brand-60',
        textClass: 'text-white'
    },
    [NewsBarColor.Gray]: {
        bgClass: 'bg-gray-10',
        textClass: 'text-black'
    },
    [NewsBarColor.Green]: {
        bgClass: 'bg-green-60',
        textClass: 'text-white'
    },
    [NewsBarColor.Custom]: {
        bgClass: 'bg-custom',
        textClass: 'text-white'
    }
};
